import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import Cookies from 'js-cookie';
import { isAdvertorial } from '../../advertorial/advertorial';

import {
  determineIfMagazine,
  determineMagazineIssueMonth,
  determineMagazineIssueNumber,
  containsTag
} from '../../../../utils/tag_category_util';
import MagazineAttribution from '../../magazine_attribution/magazine_attribution';
import Author from './author';
import NewsletterSignup from '../../newsletters/newsletter-signup';
import PersonalizedRecommendations from '../../personalized_recommendations/personalized_recommendations';
import featureFlags from '../../../../../feature_flags';

export default class Footer extends Component {
  determineNewsletter(categories, tags, currentSite) {
    if (!Array.isArray(categories)) return null;

    const categoryNewsletters = {
      leadership: '',
      'work-life': '',
      technology: '',
      ideas: '',
      impact: '',
      entertainment: '',
      creativity: '',
      news: ''
    };

    const cat = get(categories, '[0].slug', '');
    let primaryNewsletter = currentSite;

    if (categoryNewsletters.hasOwnProperty(cat)) {
      primaryNewsletter = cat;
    }

    if (containsTag(tags, 'work-smart')) {
      primaryNewsletter = 'work-smart';
    }

    if (containsTag(tags, 'ethonomics')) {
      primaryNewsletter = 'ethonomics';
    }

    if (containsTag(tags, 'well-to-do')) {
      primaryNewsletter = 'well-to-do';
    }

    if (containsTag(tags, 'hit-the-ground-running')) {
      primaryNewsletter = 'hit-the-ground-running';
    }

    return {
      primary: primaryNewsletter,
      newsletters: [
        { list: primaryNewsletter, default: true },
        { list: 'events', default: true }
      ]
    };
  }

  render() {
    const {
      post,
      isLongPost,
      hasNewsletter,
      bylineAttribution,
      config,
      promoText,
      hasFCEB,
      canRenderInfiniteScroll
    } = this.props;
    const { tags, categories, author, link } = post;
    const isMagazine = determineIfMagazine(categories);
    const hasAuthor = isLongPost && !bylineAttribution;
    const hasPersonalizedRecommendations =
      featureFlags.postPersonalizedRecommendationsEnabled &&
      !containsTag(tags, 'advertorial');
    let showNewsletterSignup = hasNewsletter;
    const isCodesign =
      categories.indexOf(categories.find(cat => cat.slug === 'co-design')) >= 0;
    const abGroupCookie = Cookies.get('abgroup');
    let defaultABGroup = 0;

    if (abGroupCookie) {
      defaultABGroup = parseInt(abGroupCookie, 10);
    }

    // Groups 1-2: Hide All
    // Groups 3-20: No video/carousel
    //                       No newsletter signup
    //                       Only two Parsley "you might also like" links
    //                       Keep Dianomi
    if (defaultABGroup >= 1 && defaultABGroup <= 2) {
      showNewsletterSignup = true;
    }
    if (defaultABGroup >= 3 && defaultABGroup <= 20) {
      showNewsletterSignup = true;
    }

    if (!isMagazine && !hasAuthor && !hasNewsletter) {
      return null;
    }

    return (
      <footer className="post__footer">
        {isMagazine ? (
          <MagazineAttribution
            issueMonth={determineMagazineIssueMonth(tags)}
            issueNumber={determineMagazineIssueNumber(tags)}
            config={config}
          />
        ) : (
          ''
        )}
        {hasAuthor ? (
          <Author modifier="post" {...author} hasFCEB={hasFCEB} />
        ) : (
          ''
        )}

        {promoText && (
          <div
            className="globalPostFooter"
            dangerouslySetInnerHTML={{ __html: promoText }}
          />
        )}

        {hasPersonalizedRecommendations && canRenderInfiniteScroll ? (
          <PersonalizedRecommendations
            post={post}
            config={config}
            link={link}
            isAdvertorial={containsTag(tags, 'advertorial')}
          />
        ) : (
          ''
        )}
        {showNewsletterSignup && canRenderInfiniteScroll ? (
          <NewsletterSignup
            modifier="post"
            id={`${post.id}`}
            isAdvertorial={isAdvertorial(tags)}
            {...this.determineNewsletter(
              categories,
              tags,
              get(config, 'site', '')
            )}
            isCodesign={isCodesign}
            title="Innovation in your inbox"
            deck="Sign up for the daily newsletter"
            hideCheckBox={true}
          />
        ) : (
          ''
        )}
      </footer>
    );
  }
}

Footer.defaultProps = {
  promoText: '',
  hasFCEB: false,
  canRenderInfiniteScroll: false
};

Footer.propTypes = {
  post: PropTypes.shape({
    tags: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    categories: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    author: PropTypes.shape({}).isRequired
  }).isRequired,
  config: PropTypes.shape({}).isRequired,
  bylineAttribution: PropTypes.string.isRequired,
  isLongPost: PropTypes.bool.isRequired,
  hasNewsletter: PropTypes.bool.isRequired,
  promoText: PropTypes.string,
  hasFCEB: PropTypes.bool,
  canRenderInfiniteScroll: PropTypes.bool
};
